import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { RoleDto } from "common/models/api/models/RoleDto";
import { default as config } from "common/config/config";

export interface AuthState {
    isLoggedIn: boolean;
    selectedRole?: RoleDto;
    setLoggedIn: (loggedIn: boolean) => void;
    setSelectedRole: (role?: RoleDto) => void;
    logout: () => void;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set) => ({
            isLoggedIn: false,
            selectedRole: undefined,
            setLoggedIn: (loggedIn) => set({ isLoggedIn: loggedIn }),
            setSelectedRole: (selectedRole) => set({ selectedRole }),
            logout: () => set({ isLoggedIn: false, selectedRole: undefined }),
        }),
        {
            name: `${config.projectName}-auth`,
            partialize: (state) => ({ selectedRole: state.selectedRole }),
            storage: createJSONStorage(() => sessionStorage),
        },
    ),
);
